import React, { useState, useEffect, useRef } from 'react';
import {
    Container, Row, Col, Card, Button, Form, Table,
    Tabs, Tab, Alert, Modal, Badge,
    InputGroup
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import DataApi from '../../api/dataApi';
import Loader from '../common/Loader';
import { toast } from "react-toastify";
import PurchaseDataImport from "../common/PurchaseDataImport";
import UniversalBarcodeScanner from './UniversalBarcodeScanner';
import PubSub from 'pubsub-js';
import "../../App.css";
import PermissionDenied from '../../utils/permission_denied';
import { Country, State, City } from 'country-state-city';
import { COUNTRY_CODES } from '../../constants/COUNTRY_CODES';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BulkPurchasePage = ({ permissions }) => {


    const navigate = useNavigate();


    const [multiInsertRows, setMultiInsertRows] = useState([{
        vendor_id: "",
        book_id: "",
        quantity: 1,
        unit_price: 0,
        purchase_date: new Date().toISOString().split('T')[0],
        notes: ""
    }]);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [vendors, setVendors] = useState([]);
    const [books, setBooks] = useState([]);
    const [saving, setSaving] = useState(false);
    const [activeTab, setActiveTab] = useState("single");
    const [selectedFile, setSelectedFile] = useState(null);
    const [barcodeInput, setBarcodeInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [stats, setStats] = useState({
        issued: 0,
        purchased: 0,
        available: 0
    });

    const [showAddVendorModal, setShowAddVendorModal] = useState(false);
    const [showAddBookModal, setShowAddBookModal] = useState(false);
    const [vendorFormData, setVendorFormData] = useState({
        name: "",
        company_name: "",
        email: "",
        phone: "",
        country_code: "+91",
        gst_number: "",
        pan_number: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        country: "India",
        status: true,
    });




    const [bookFormData, setBookFormData] = useState({
        title: "",
        author_id: "",
        category_id: "",
        isbn: "",
        language: "",
    });
    const [authors, setAuthors] = useState([]);
    const [categories, setCategories] = useState([]);
    const [autoLookupTimeout, setAutoLookupTimeout] = useState(null);
    const [barcodeProcessing, setBarcodeProcessing] = useState(false);
    const [company, setCompany] = useState("");


    const GOOGLE_BOOKS_API_KEY = "AIzaSyAC2OqFGAIdOaCSWswm-mjiwoY-kzPJT-0";

    function getCompanyIdFromToken() {
        const token = sessionStorage.getItem("token");
        if (!token) return null;

        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.companyid || payload.companyid || null;
    }

    const fetchCompany = async () => {
        try {
            const companyid = getCompanyIdFromToken();
            if (!companyid) {
                console.error("Company ID not found in token");
                return;
            }
            const companyApi = new DataApi("company");
            const response = await companyApi.fetchById(companyid);

            if (response.data) {
                setCompany(response.data);
            }
        } catch (error) {
            console.error("Error fetching company by ID:", error);
        }
    };

    useEffect(() => {
        fetchCompany();
        fetchVendors();
        fetchBooks();
        fetchAuthors();
        fetchCategories();
        fetchStats();
    }, []);

    useEffect(() => {
        if (showAddBookModal) {
            setBookFormData({
                title: "",
                author_id: "",
                category_id: "",
                isbn: barcodeInput || "",
                language: "",
            });
        }
    }, [showAddBookModal]);

    const fetchStats = async () => {
        try {
            const issuedApi = new DataApi("bookissue");
            const issuedResponse = await issuedApi.fetchAll();

            const purchaseApi = new DataApi("purchase");
            const purchaseResponse = await purchaseApi.fetchAll();

            const bookApi = new DataApi("book/active");
            const bookResponse = await bookApi.fetchAll();

            let currentIssuedCount = 0;
            let totalIssuedRecords = 0;
            let returnedCount = 0;
            let purchasedCount = 0;
            let availableCount = 0;
            let totalBooksCount = 0;

            const issuedData = Array.isArray(issuedResponse.data) ? issuedResponse.data : (issuedResponse.data?.data || []);
            if (issuedData.length > 0) {
                totalIssuedRecords = issuedData.length;
                currentIssuedCount = issuedData.filter(issue =>
                    issue.status && issue.status.toLowerCase() === "issued"
                ).length;
                returnedCount = issuedData.filter(issue =>
                    issue.status && issue.status.toLowerCase() === "submitted"
                ).length;
            }

            const purchaseData = Array.isArray(purchaseResponse.data) ? purchaseResponse.data : (purchaseResponse.data?.data || []);
            if (purchaseData.length > 0) {
                purchasedCount = purchaseData.reduce((sum, purchase) =>
                    sum + (parseInt(purchase.quantity) || 0), 0);
            }

            const bookDataArr = Array.isArray(bookResponse.data) ? bookResponse.data : (bookResponse.data?.data || []);
            if (bookDataArr.length > 0) {
                totalBooksCount = bookDataArr.length;
                availableCount = bookDataArr.reduce((sum, book) =>
                    sum + (parseInt(book.available_copies) || 0), 0);
            }

            setStats({
                issued: currentIssuedCount,
                purchased: purchasedCount,
                available: availableCount,
                totalIssuedRecords: totalIssuedRecords,
                returnedBooks: returnedCount,
                totalBooks: totalBooksCount
            });

        } catch (error) {
            console.error("Error fetching stats:", error);
        }
    };

    const handleFileChange = (file) => {
        if (file) {
            setSelectedFile(file);
        } else {
            setSelectedFile(null);
        }
    };

    const isValidISBN = (isbn) => {
        if (!isbn) return false;

        const cleanIsbn = isbn.replace(/[^\dX]/gi, '').toUpperCase();

        if (cleanIsbn.length === 10) {
            const isbn10Regex = /^[\d]{9}[\dX]$/;
            if (isbn10Regex.test(cleanIsbn)) {
                return { type: 'isbn10', value: cleanIsbn };
            }
        }

        if (cleanIsbn.length === 13) {
            const isbn13Regex = /^[\d]{13}$/;
            if (isbn13Regex.test(cleanIsbn)) {
                return { type: 'isbn13', value: cleanIsbn };
            }
        }

        return false;
    };

    const fetchBookByISBN = async (isbn) => {

        const bookData = {
            isbn: isbn,
            title: "",
            total_copies: 1,
            available_copies: 1,
            language: "English"
        };

        try {

            const googleBooksUrl = `https://www.googleapis.com/books/v1/volumes?q=isbn:${isbn}&key=${GOOGLE_BOOKS_API_KEY}`;


            const googleResponse = await fetch(googleBooksUrl);

            if (googleResponse.ok) {
                const data = await googleResponse.json();


                if (data.items && data.items.length > 0) {
                    const volumeInfo = data.items[0].volumeInfo;


                    bookData.title = volumeInfo.title || "";


                    if (volumeInfo.authors && volumeInfo.authors.length > 0) {
                        bookData.author_name = volumeInfo.authors.join(", ");
                        bookData.author_details = {
                            name: volumeInfo.authors[0],
                            bio: "",
                            email: "",
                            fullData: null
                        };
                    }


                    if (volumeInfo.categories && volumeInfo.categories.length > 0) {
                        const category = volumeInfo.categories[0];
                        const categoryName = category
                            .split("/")[0]
                            .split(",")[0]
                            .trim();
                        bookData.category_name = categoryName;
                        bookData.category_description = category;
                    }


                    if (volumeInfo.language) {
                        bookData.language = volumeInfo.language.toUpperCase();
                    }


                    if (volumeInfo.description) {
                        bookData.description = volumeInfo.description;
                    }


                    if (volumeInfo.publishedDate) {
                        bookData.published_date = volumeInfo.publishedDate;
                    }


                    if (volumeInfo.publisher) {
                        bookData.publisher = volumeInfo.publisher;
                    }


                    if (volumeInfo.pageCount) {
                        bookData.page_count = volumeInfo.pageCount;
                    }


                    return bookData;
                } else {


                    const titleSearchUrl = `https://www.googleapis.com/books/v1/volumes?q=${encodeURIComponent(isbn)}&key=${GOOGLE_BOOKS_API_KEY}`;
                    const titleResponse = await fetch(titleSearchUrl);

                    if (titleResponse.ok) {
                        const titleData = await titleResponse.json();
                        if (titleData.items && titleData.items.length > 0) {
                            const volumeInfo = titleData.items[0].volumeInfo;
                            bookData.title = volumeInfo.title || isbn;

                            if (volumeInfo.authors && volumeInfo.authors.length > 0) {
                                bookData.author_name = volumeInfo.authors.join(", ");
                            }


                            return bookData;
                        }
                    }
                }
            }
        } catch (error) {

        }


        return bookData;
    };

    const findOrCreateAuthor = async (authorName, authorDetails = null) => {
        try {
            const authorApi = new DataApi("author");
            const authorsResponse = await authorApi.fetchAll();

            if (authorsResponse.data && Array.isArray(authorsResponse.data)) {
                const authorNames = authorName.split(",").map(a => a.trim());
                const primaryAuthorName = authorNames[0];

                let foundAuthor = authorsResponse.data.find(a =>
                    a.name && a.name.toLowerCase() === primaryAuthorName.toLowerCase()
                );

                if (!foundAuthor) {
                    const authorData = {
                        name: primaryAuthorName,
                        email: authorDetails?.email || "",
                        bio: authorDetails?.bio || ""
                    };

                    const newAuthorResponse = await authorApi.create(authorData);
                    if (newAuthorResponse.data && newAuthorResponse.data.success) {
                        foundAuthor = newAuthorResponse.data.data;
                        PubSub.publish("RECORD_SAVED_TOAST", { message: `Author "${primaryAuthorName}" created successfully` });
                        await fetchAuthors();
                    }
                }

                if (foundAuthor) {
                    return foundAuthor.id;
                }
            }
        } catch (error) {
            console.error("Error finding/creating author:", error);
            PubSub.publish("RECORD_ERROR_TOAST", { title: "Author Error", message: "Error creating author" });
        }
        return null;
    };

    const findOrCreateCategory = async (categoryName, categoryDescription = null) => {
        try {
            const categoryApi = new DataApi("category");
            const categoriesResponse = await categoryApi.fetchAll();

            if (categoriesResponse.data && Array.isArray(categoriesResponse.data)) {
                let foundCategory = categoriesResponse.data.find(c =>
                    c.name && c.name.toLowerCase() === categoryName.toLowerCase()
                );

                if (!foundCategory) {
                    const categoryData = {
                        name: categoryName,
                        description: categoryDescription || ""
                    };

                    const newCategoryResponse = await categoryApi.create(categoryData);
                    if (newCategoryResponse.data && newCategoryResponse.data.success) {
                        foundCategory = newCategoryResponse.data.data;
                        toast.success(`Category "${categoryName}" created successfully`);
                        await fetchCategories();
                    }
                }

                if (foundCategory) {
                    return foundCategory.id;
                }
            }
        } catch (error) {
            console.error("Error finding/creating category:", error);
            PubSub.publish("RECORD_ERROR_TOAST", { title: "Category Error", message: "Error creating category" });
        }
        return null;
    };

    const processBarcodeData = async (barcode) => {
        if (!barcode || barcode.trim().length === 0) return null;

        setBarcodeProcessing(true);
        try {


            const isbnCheck = isValidISBN(barcode);
            if (isbnCheck) {

                const isbn = isbnCheck.value;

                const bookData = await fetchBookByISBN(isbn);



                if (bookData.author_name) {
                    const authorId = await findOrCreateAuthor(bookData.author_name, bookData.author_details);
                    if (authorId) {
                        bookData.author_id = authorId;
                    }
                }


                if (bookData.category_name) {
                    const categoryId = await findOrCreateCategory(bookData.category_name, bookData.category_description);
                    if (categoryId) {
                        bookData.category_id = categoryId;
                    }
                }

                return {
                    title: bookData.title || "",
                    author_id: bookData.author_id || "",
                    category_id: bookData.category_id || "",
                    isbn: bookData.isbn || isbn,
                    language: bookData.language || "English",
                };
            }


            if (/\d/.test(barcode) && /[A-Za-z]/.test(barcode)) {
                const possibleIsbns = barcode.match(/[\dX]{10,13}/g);
                if (possibleIsbns) {
                    for (const possibleIsbn of possibleIsbns) {
                        const isbnCheck = isValidISBN(possibleIsbn);
                        if (isbnCheck) {
                            const isbn = isbnCheck.value;
                            const title = barcode.replace(possibleIsbn, "").trim();

                            const bookData = await fetchBookByISBN(isbn);

                            if (title && !bookData.title) {
                                bookData.title = title;
                            }

                            if (bookData.author_name) {
                                const authorId = await findOrCreateAuthor(bookData.author_name, bookData.author_details);
                                if (authorId) {
                                    bookData.author_id = authorId;
                                }
                            }

                            if (bookData.category_name) {
                                const categoryId = await findOrCreateCategory(bookData.category_name, bookData.category_description);
                                if (categoryId) {
                                    bookData.category_id = categoryId;
                                }
                            }

                            return {
                                title: bookData.title || title || "",
                                author_id: bookData.author_id || "",
                                category_id: bookData.category_id || "",
                                isbn: bookData.isbn || isbn,
                                language: bookData.language || "English",
                            };
                        }
                    }
                }
            }


            if (barcode.length > 3) {
                return {
                    title: barcode.trim(),
                    author_id: "",
                    category_id: "",
                    isbn: barcode,
                    language: "English",
                };
            }

            return null;
        } catch (error) {
            console.error("Error processing barcode data:", error);
            PubSub.publish("RECORD_ERROR_TOAST", { title: "Processing Error", message: "Failed to process barcode data" });
            return null;
        } finally {
            setBarcodeProcessing(false);
        }
    };

    const handleBarcodeLookup = async (barcode) => {
        if (!barcode.trim()) {
            PubSub.publish("RECORD_ERROR_TOAST", { title: "Validation Error", message: "Please enter a barcode/ISBN" });
            return;
        }

        try {
            setLoading(true);
            const processedData = await processBarcodeData(barcode.trim());

            if (processedData) {
                setBookFormData(prev => ({
                    ...prev,
                    ...processedData
                }));

                setBarcodeInput(processedData.isbn || barcode);

                if (processedData.title) {
                    toast.success(`Book data loaded: ${processedData.title}`);
                } else {
                    toast.info("Basic book data prepared. Please fill remaining details.");
                }
            } else {
                setBookFormData(prev => ({
                    ...prev,
                    isbn: barcode,
                    title: barcode.length > 50 ? barcode.substring(0, 50) + "..." : barcode
                }));
                toast.info("Could not auto-detect book details. Please fill manually.");
            }
        } catch (error) {
            console.error('Barcode lookup error:', error);
            setBookFormData(prev => ({
                ...prev,
                isbn: barcode
            }));
            PubSub.publish("RECORD_ERROR_TOAST", { title: "Processing Error", message: "Failed to process barcode. Please check the format and try again." });
        } finally {
            setLoading(false);
        }
    };

    const handleBarcodeScanned = (barcode) => {

        setBarcodeInput(barcode);

        setTimeout(() => {
            handleBarcodeLookup(barcode);
        }, 500);
    };

    const fetchVendors = async () => {
        try {
            const vendorApi = new DataApi("vendor/active");
            const response = await vendorApi.fetchAll();

            if (response.data) {
                const vendorData = Array.isArray(response.data) ? response.data : (response.data.data || []);
                setVendors(vendorData);
            }
        } catch (error) {
            console.error("Error fetching vendors:", error);
        }
    };

    const fetchBooks = async () => {
        try {
            const bookApi = new DataApi("book/active");
            const response = await bookApi.fetchAll();
            if (response.data) {
                const bookData = Array.isArray(response.data) ? response.data : (response.data.data || []);
                setBooks(bookData);
            }
        } catch (error) {
            console.error("Error fetching books:", error);
        }
    };

    const fetchAuthors = async () => {
        try {
            const authorApi = new DataApi("author");
            const response = await authorApi.fetchAll();
            if (response.data) {
                setAuthors(response.data);
            }
        } catch (error) {
            console.error("Error fetching authors:", error);
        }
    };

    const fetchCategories = async () => {
        try {
            const categoryApi = new DataApi("category");
            const response = await categoryApi.fetchAll();
            if (response.data) {
                setCategories(response.data);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const vendorOptions = vendors.map((vendor) => ({
        value: vendor.id,
        label: vendor.name
    }));

    const bookOptions = books.map((book) => ({
        value: book.id,
        label: `${book.title}${book.isbn ? ` (${book.isbn})` : ''}`
    }));

    const authorOptions = authors.map((author) => ({
        value: author.id,
        label: author.name
    }));

    const categoryOptions = categories.map((category) => ({
        value: category.id,
        label: category.name
    }));

    const getSelectedAuthor = () => {
        if (!bookFormData.author_id) return null;
        return authorOptions.find(option => option.value === bookFormData.author_id) || null;
    };

    const getSelectedCategory = () => {
        if (!bookFormData.category_id) return null;
        return categoryOptions.find(option => option.value === bookFormData.category_id) || null;
    };

    const getSelectedBook = (rowIndex) => {
        const row = multiInsertRows[rowIndex];
        if (!row.book_id) return null;
        return bookOptions.find(option => option.value === row.book_id) || null;
    };

    const getSelectedVendorForRow = (rowIndex) => {
        const row = multiInsertRows[rowIndex];
        if (!row.vendor_id) return null;
        return vendorOptions.find(option => option.value === row.vendor_id) || null;
    };

    const handleMultiRowChange = (index, field, value) => {
        const updatedRows = [...multiInsertRows];
        if (field === "quantity" || field === "unit_price") {
            value = Math.floor(Number(value));
        }
        updatedRows[index] = { ...updatedRows[index], [field]: value };
        setMultiInsertRows(updatedRows);
    };

    const handleAddBookRow = () => {
        const newRow = {
            vendor_id: activeTab === "single" ? (selectedVendor ? selectedVendor.value : "") : "",
            book_id: "",
            quantity: 1,
            unit_price: 0,
            purchase_date: new Date().toISOString().split('T')[0],
            notes: ""
        };
        setMultiInsertRows([...multiInsertRows, newRow]);
    };

    const handleRemoveRow = (index) => {
        if (multiInsertRows.length > 1) {
            const updatedRows = multiInsertRows.filter((_, i) => i !== index);
            setMultiInsertRows(updatedRows);
        }
    };

    const handleVendorChange = (selectedOption) => {
        setSelectedVendor(selectedOption);

        if (activeTab === "single") {
            const vendorId = selectedOption ? selectedOption.value : "";

            const updatedRows = multiInsertRows.map(row => {
                if (!row.vendor_id || row.vendor_id === "") {
                    return {
                        ...row,
                        vendor_id: vendorId
                    };
                }
                return row;
            });

            setMultiInsertRows(updatedRows);
        }
    };

    // const handleAddVendor = async () => {
    //     if (!vendorFormData.name || !vendorFormData.name.trim()) {
    //         PubSub.publish("RECORD_ERROR_TOAST", { title: "Validation Error", message: "Vendor name is required" });
    //         return;
    //     }

    //     try {
    //         setLoading(true);
    //         const vendorApi = new DataApi("vendor");
    //         const response = await vendorApi.create(vendorFormData);

    //         if (response.data) {
    //             toast.success("Vendor added successfully");
    //             setShowAddVendorModal(false);
    //             setVendorFormData({
    //                 name: "",
    //                 company_name: "",
    //                 email: "",
    //                 phone: "",
    //                 address: "",
    //                 city: "",
    //                 state: "",
    //                 pincode: "",
    //                 country: "India",
    //                 status: "active",
    //             });
    //             await fetchVendors();
    //         }
    //     } catch (error) {
    //         console.error("Error adding vendor:", error);
    //         PubSub.publish("RECORD_ERROR_TOAST", { title: "Creation Error", message: "Failed to add vendor" });
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    const handleAddVendor = async () => {
        if (!vendorFormData.name?.trim()) {
            PubSub.publish("RECORD_ERROR_TOAST", {
                title: "Validation Error",
                message: "Vendor name is required",
            });
            return;
        }

        try {
            setLoading(true);

            const vendorApi = new DataApi("vendor");
            const response = await vendorApi.create(vendorFormData);

            console.log("Vendor create response =>", response);


            if (response?.data?.success || response?.status === 201 || response?.data) {
                toast.success("Vendor added successfully ");

                setShowAddVendorModal(false);

                setVendorFormData({
                    name: "",
                    company_name: "",
                    email: "",
                    phone: "",
                    country_code: "+91",
                    gst_number: "",
                    pan_number: "",
                    address: "",
                    city: "",
                    state: "",
                    pincode: "",
                    country: "India",
                    status: true,
                });

                await fetchVendors();
            } else {
                toast.error("Something went wrong while adding vendor");
            }
        } catch (error) {
            console.error("Error adding vendor:", error);

            toast.error(
                error?.response?.data?.message || "Failed to add vendor"
            );
        } finally {
            setLoading(false);
        }
    };

    const handleAddBook = async () => {
        if (!bookFormData.title || !bookFormData.title.trim()) {
            PubSub.publish("RECORD_ERROR_TOAST", { title: "Validation Error", message: "Book title is required" });
            return;
        }

        if (!bookFormData.author_id) {
            PubSub.publish("RECORD_ERROR_TOAST", { title: "Validation Error", message: "Author is required" });
            return;
        }

        if (!bookFormData.category_id) {
            PubSub.publish("RECORD_ERROR_TOAST", { title: "Validation Error", message: "Category is required" });
            return;
        }

        try {
            setLoading(true);
            const bookApi = new DataApi("book/active");


            const bookDataToSend = {
                ...bookFormData,
                title: bookFormData.title.trim(),
                language: bookFormData.language || "English",
            };

            const response = await bookApi.create(bookDataToSend);

            if (response && response.data) {
                let newBookId = null;
                const bookData = response.data;


                newBookId = bookData.id || bookData._id ||
                    (bookData.data && (bookData.data.id || bookData.data._id));

                if (newBookId) {
                    await fetchBooks();
                    toast.success("Book added successfully");

                    setTimeout(() => {
                        setShowAddBookModal(false);
                        setBarcodeInput("");
                    }, 300);

                    setBookFormData({
                        title: "",
                        author_id: "",
                        category_id: "",
                        isbn: "",
                        language: "",
                    });
                } else {
                    PubSub.publish("RECORD_ERROR_TOAST", { title: "Creation Error", message: "Book created but could not get book ID" });
                    setShowAddBookModal(false);
                }
            } else {
                PubSub.publish("RECORD_ERROR_TOAST", { title: "Creation Error", message: "Failed to add book" });
            }
        } catch (error) {
            console.error("Error adding book:", error);
            PubSub.publish("RECORD_ERROR_TOAST", { title: "Creation Error", message: "Failed to add book: " + (error.message || "Unknown error") });
        } finally {
            setLoading(false);
        }
    };

    const handleSavePurchases = async () => {
        // Enhanced validation with specific field error messages
        const validationErrors = [];
        multiInsertRows.forEach((row, index) => {
            const missingFields = [];
            if (!row.vendor_id) missingFields.push("Vendor");
            if (!row.book_id) missingFields.push("Book");
            if (!row.quantity || row.quantity <= 0) missingFields.push("Quantity");
            if (!row.unit_price || row.unit_price <= 0) missingFields.push("Unit Price");

            if (missingFields.length > 0) {
                validationErrors.push(`Row ${index + 1}: Missing ${missingFields.join(", ")}`);
            }
        });

        if (validationErrors.length > 0) {
            PubSub.publish("RECORD_ERROR_TOAST", {
                title: "Validation Error",
                message: validationErrors.join("; ")
            });
            return;
        }

        const convertedData = multiInsertRows
            .map((row) => ({
                vendor_id: row.vendor_id,
                book_id: row.book_id,
                quantity: parseInt(row.quantity) || 1,
                unit_price: parseFloat(row.unit_price) || 0,
                purchase_date: row.purchase_date || new Date().toISOString().split('T')[0],
                notes: row.notes || "",
                total_amount: (parseInt(row.quantity) || 1) * (parseFloat(row.unit_price) || 0),
            }));

        if (convertedData.length === 0) {
            PubSub.publish("RECORD_ERROR_TOAST", { title: "Validation Error", message: "Please fill at least one complete purchase entry" });
            return;
        }

        try {
            setSaving(true);
            const purchaseApi = new DataApi("purchase");
            const bookCopyApi = new DataApi("book-copy");
            let successCount = 0;
            let failCount = 0;

            for (let i = 0; i < convertedData.length; i++) {
                const purchaseData = convertedData[i];
                try {
                    const purchaseResponse = await purchaseApi.create(purchaseData);

                    if (purchaseResponse.data && purchaseResponse.data.success) {
                        // Automatically create book copies in bulk
                        try {
                            await bookCopyApi.post('/bulk', {
                                book_id: purchaseData.book_id,
                                quantity: purchaseData.quantity,
                                item_price: purchaseData.unit_price
                            });
                        } catch (copyErr) {
                            console.error("Error creating copies for purchase row", i + 1, ":", copyErr);
                            // We don't necessarily want to fail the whole thing if copies fail, 
                            // but we should log it
                        }
                    }

                    successCount++;
                    PubSub.publish("RECORD_SAVED_TOAST", {
                        message: `Purchase record ${i + 1} saved successfully`
                    });
                } catch (error) {
                    console.error("Error creating purchase:", error);
                    failCount++;
                    const errorMsg = error.response?.data?.error || error.response?.data?.errors || error.message || "Failed to create purchase";
                    PubSub.publish("RECORD_ERROR_TOAST", {
                        title: "Purchase Error",
                        message: `Row ${i + 1}: ${errorMsg}`
                    });
                }
            }

            if (successCount > 0) {
                toast.success(`Successfully created ${successCount} purchase${successCount > 1 ? 's' : ''}. Redirecting to purchases list...`);
                setMultiInsertRows([{
                    vendor_id: "",
                    book_id: "",
                    quantity: 1,
                    unit_price: 0,
                    purchase_date: new Date().toISOString().split('T')[0],
                    notes: ""
                }]);
                setSelectedVendor(null);
                navigate('/purchase');
            }

            if (failCount > 0) {
                PubSub.publish("RECORD_ERROR_TOAST", { title: "Creation Error", message: `Failed to create ${failCount} purchase${failCount > 1 ? 's' : ''}` });
            }
        } catch (error) {
            console.error("Error in bulk insert:", error);
            const errorMsg = error.response?.data?.error || error.response?.data?.errors || error.message || "Failed to save purchases";
            PubSub.publish("RECORD_ERROR_TOAST", {
                title: "Error",
                message: errorMsg
            });
        } finally {
            setSaving(false);
        }
    };

    const totalAmount = multiInsertRows.reduce((sum, row) => sum + ((parseFloat(row.quantity) || 0) * (parseFloat(row.unit_price) || 0)), 0);
    const uniqueVendors = [...new Set(multiInsertRows.map(row => row.vendor_id).filter(Boolean))];
    const totalBooks = multiInsertRows.reduce((sum, row) => sum + (parseInt(row.quantity) || 0), 0);

    if (loading) {
        // return <Loader />;
        <span className="loader"></span>
    }

    if (!permissions?.allowCreate) {
        return <PermissionDenied />;
    }

    const todayStr = new Date().toISOString().split("T")[0];

    const renderTabContent = () => {
        switch (activeTab) {
            case "single":
                return (
                    <>
                        <Row className="align-items-center mb-4">
                            <Col lg={8}>
                                <Form.Group>
                                    <Form.Label className="fw-bold mb-2">
                                        Select Default Vendor<span className="text-danger">*</span>
                                    </Form.Label>
                                    <Select
                                        value={selectedVendor}
                                        onChange={handleVendorChange}
                                        options={vendorOptions}
                                        placeholder="Choose default vendor for all rows..."
                                        isClearable
                                        isSearchable
                                        menuPlacement="auto"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: "45px",
                                                fontSize: "16px",
                                                border: "2px solid var(--primary-color)",
                                                borderRadius: "8px",
                                                "&:hover": {
                                                    borderColor: "#8b5cf6",
                                                },
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999
                                            })
                                        }}
                                        menuPortalTarget={document.body}
                                        menuShouldScrollIntoView={false}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={2}></Col>
                            <Col lg={2} className="d-flex justify-content-end">
                                <button
                                    className="custom-btn-primary"
                                    onClick={handleAddBookRow}
                                >
                                    <i className="fa-solid fa-plus me-1"></i>
                                    Add New Row
                                </button>
                            </Col>
                        </Row>

                        {/* Purchase Items Table */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="mb-0">
                                Purchase Items ({multiInsertRows.length})
                            </h6>
                        </div>

                        <div className="border rounded" style={{
                            overflow: 'auto',
                            backgroundColor: 'white',
                            width: '100%',
                            position: 'relative',
                            zIndex: 1
                        }}>
                            <div style={{
                                minWidth: '1200px',
                                width: '100%',
                                position: 'relative',
                                zIndex: 1
                            }}>

                                <Table bordered hover className="mb-0" style={{ width: '100%', tableLayout: 'fixed' }}>
                                    <thead style={{
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        backgroundColor: '#f8f9fa'
                                    }}>
                                        <tr>
                                            <th style={{ background: 'var(--primary-background-color)', width: '22%' }} >

                                                <span>Vendor</span>
                                                <span className="text-danger ms-1">*</span>

                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '22%' }} >
                                                <div className="d-flex align-items-center">
                                                    <span>Book</span>
                                                    <span className="text-danger ms-1">*</span>
                                                </div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '8%' }}>
                                                <div className="d-flex align-items-center">
                                                    <span>Qty</span>
                                                    <span className="text-danger ms-1">*</span>
                                                </div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '10%' }} >
                                                <div className="d-flex align-items-center">
                                                    <span>Unit Price</span>
                                                    <span className="text-danger ms-1">*</span>
                                                </div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '12%' }} >
                                                <div className="text-center">Total Amount</div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '12%' }}>
                                                <div>Purchase Date</div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '12%' }} >
                                                <div>Notes</div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '12%' }} >
                                                <div>Actions</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {multiInsertRows.map((row, index) => (
                                            <tr key={index} className={index % 2 === 0 ? 'table-row-light' : ''}>
                                                <td className="border-end p-2" style={{ width: '22%' }}>
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <div className="flex-grow-1" style={{ minWidth: '0' }}>
                                                            <Select
                                                                value={getSelectedVendorForRow(index)}
                                                                onChange={(selectedOption) => handleMultiRowChange(index, "vendor_id", selectedOption ? selectedOption.value : "")}
                                                                options={vendorOptions}
                                                                placeholder="Select Vendor"
                                                                isClearable
                                                                isSearchable
                                                                menuPlacement="auto"
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        width: "100%",
                                                                        minHeight: "36px",
                                                                        fontSize: "14px",
                                                                        borderColor: state.isFocused ? "#8b5cf6" : row.vendor_id ? "#28a745" : "#dee2e6",
                                                                        backgroundColor: row.vendor_id ? "#f8fff9" : "white",
                                                                        "&:hover": {
                                                                            borderColor: row.vendor_id ? "#28a745" : "#8b5cf6",
                                                                        },
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999
                                                                    }),
                                                                    singleValue: (base) => ({
                                                                        ...base,
                                                                        maxWidth: 'calc(100% - 40px)',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap'
                                                                    }),
                                                                    placeholder: (base) => ({
                                                                        ...base,
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap'
                                                                    })
                                                                }}
                                                                menuPortalTarget={document.body}
                                                                menuShouldScrollIntoView={false}
                                                            />
                                                        </div>
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={() => setShowAddVendorModal(true)}
                                                            title="Add New Vendor"
                                                            className="p-0 text-primary flex-shrink-0"
                                                        >
                                                            <i className="fs-5 fa-solid fa-plus-square"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '22%' }}>
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <div className="flex-grow-1" style={{ minWidth: '0' }}>
                                                            <Select
                                                                value={getSelectedBook(index)}
                                                                onChange={(selectedOption) => handleMultiRowChange(index, "book_id", selectedOption ? selectedOption.value : "")}
                                                                options={bookOptions}
                                                                placeholder="Select Book"
                                                                isClearable
                                                                isSearchable
                                                                menuPlacement="auto"
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        width: "100%",
                                                                        minHeight: "36px",
                                                                        fontSize: "14px",
                                                                        borderColor: state.isFocused ? "#8b5cf6" : row.book_id ? "#28a745" : "#dee2e6",
                                                                        backgroundColor: row.book_id ? "#f8fff9" : "white",
                                                                        "&:hover": {
                                                                            borderColor: row.book_id ? "#28a745" : "#8b5cf6",
                                                                        },
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999
                                                                    }),
                                                                    singleValue: (base) => ({
                                                                        ...base,
                                                                        maxWidth: 'calc(100% - 40px)',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap'
                                                                    }),
                                                                    placeholder: (base) => ({
                                                                        ...base,
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap'
                                                                    })
                                                                }}
                                                                menuPortalTarget={document.body}
                                                                menuShouldScrollIntoView={false}
                                                            />
                                                        </div>
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={() => setShowAddBookModal(true)}
                                                            title="Add New Book"
                                                            className="p-0 text-success flex-shrink-0"
                                                        >
                                                            <i className="fs-5 fa-solid fa-plus-square"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '8%' }}>
                                                    <Form.Control
                                                        type="number"
                                                        value={row.quantity}
                                                        min="1"
                                                        step="1"
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            const intValue = Math.floor(Number(value));

                                                            handleMultiRowChange(index, "quantity", intValue < 1 ? 1 : intValue);
                                                        }}
                                                        className="border-0 p-1"
                                                    />

                                                </td>
                                                <td className="border-end p-2" style={{ width: '10%' }}>
                                                    <Form.Control
                                                        type="number"
                                                        value={row.unit_price}
                                                        min="0"
                                                        step="1"
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            const intValue = Math.floor(Number(value));

                                                            handleMultiRowChange(index, "unit_price", intValue < 0 ? 0 : intValue);
                                                        }}
                                                        className="border-0 p-1"
                                                    />

                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <div className="bg-light p-2 rounded text-center">
                                                        <span className="fw-semibold text-primary">
                                                            {company?.currency} {((parseFloat(row.quantity) || 0) * (parseFloat(row.unit_price) || 0)).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <Form.Control
                                                        type="date"
                                                        value={row.purchase_date}
                                                        max={todayStr}
                                                        onChange={(e) => handleMultiRowChange(index, "purchase_date", e.target.value)}
                                                        className="border-0 p-1"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <Form.Control
                                                        type="text"
                                                        value={row.notes}
                                                        onChange={(e) => handleMultiRowChange(index, "notes", e.target.value)}
                                                        placeholder="Add notes..."
                                                        className="border-0 p-1"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="text-center p-1" style={{ width: '2%' }}>
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        onClick={() => handleRemoveRow(index)}
                                                        disabled={multiInsertRows.length === 1}
                                                        title="Remove Row"
                                                        className="p-1 text-danger"
                                                        style={{ minWidth: 'auto' }}
                                                    >
                                                        <i className="fa-solid fa-trash fa-sm"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                {/* <Table bordered hover className="mb-0" style={{ width: '100%', tableLayout: 'fixed' }}>
                                    <thead style={{
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        backgroundColor: '#f8f9fa'
                                    }}>
                                        <tr>
                                            <th style={{ background: 'var( --primary-background-color)' }} className="border-end p-3">
                                                <div className="d-flex align-items-center">
                                                    <span>Vendor</span>
                                                    <span className="text-danger ms-1">*</span>
                                                </div>
                                            </th>
                                            <th style={{ background: 'var( --primary-background-color)' }} className="border-end p-3">
                                                <div className="d-flex align-items-center">
                                                    <span>Book</span>
                                                    <span className="text-danger ms-1">*</span>
                                                </div>
                                            </th>
                                            <th style={{ background: 'var( --primary-background-color)' }} className="border-end p-3">
                                                <div className="d-flex align-items-center">
                                                    <span>Qty</span>
                                                    <span className="text-danger ms-1">*</span>
                                                </div>
                                            </th>
                                            <th style={{ background: 'var( --primary-background-color)' }} className="border-end p-3">
                                                <div className="d-flex align-items-center">
                                                    <span>Unit Price</span>
                                                    <span className="text-danger ms-1">*</span>
                                                </div>
                                            </th>
                                            <th style={{ background: 'var( --primary-background-color)' }} className="border-end p-3">
                                                <div>Total Amount</div>
                                            </th>
                                            <th style={{ background: 'var( --primary-background-color)' }} className="border-end p-3">
                                                <div>Purchase Date</div>
                                            </th>
                                            <th style={{ background: 'var( --primary-background-color)' }} className="border-end p-3">
                                                <div>Notes</div>
                                            </th>
                                            <th style={{ background: 'var( --primary-background-color)' }} className="text-center p-3">
                                                <div>Actions</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {multiInsertRows.map((row, index) => (
                                            <tr key={index} className={index % 2 === 0 ? 'table-row-light' : ''}>
                                                <td className="border-end p-2" style={{ width: '20%' }}>
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <div className="flex-grow-1">
                                                            <Select
                                                                value={getSelectedVendorForRow(index)}
                                                                onChange={(selectedOption) => handleMultiRowChange(index, "vendor_id", selectedOption ? selectedOption.value : "")}
                                                                options={vendorOptions}
                                                                placeholder="Select Vendor"
                                                                isClearable
                                                                isSearchable
                                                                menuPlacement="auto"
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        width: "100%",
                                                                        minHeight: "36px",
                                                                        fontSize: "14px",
                                                                        borderColor: state.isFocused ? "#8b5cf6" : row.vendor_id ? "#28a745" : "#dee2e6",
                                                                        backgroundColor: row.vendor_id ? "#f8fff9" : "white",
                                                                        "&:hover": {
                                                                            borderColor: row.vendor_id ? "#28a745" : "#8b5cf6",
                                                                        },
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999
                                                                    })
                                                                }}
                                                                menuPortalTarget={document.body}
                                                                menuShouldScrollIntoView={false}
                                                            />
                                                        </div>
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={() => setShowAddVendorModal(true)}
                                                            title="Add New Vendor33"
                                                            className="p-0 text-primary"
                                                        >
                                                            <i className="fs-4 fa-solid fa-plus-square"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '25%' }}>
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <div className="flex-grow-1">
                                                            <Select
                                                                value={getSelectedBook(index)}
                                                                onChange={(selectedOption) => handleMultiRowChange(index, "book_id", selectedOption ? selectedOption.value : "")}
                                                                options={bookOptions}
                                                                placeholder="Select Book"
                                                                isClearable
                                                                isSearchable
                                                                menuPlacement="auto"
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        width: "100%",
                                                                        minHeight: "36px",
                                                                        fontSize: "14px",
                                                                        borderColor: state.isFocused ? "#8b5cf6" : row.book_id ? "#28a745" : "#dee2e6",
                                                                        backgroundColor: row.book_id ? "#f8fff9" : "white",
                                                                        "&:hover": {
                                                                            borderColor: row.book_id ? "#28a745" : "#8b5cf6",
                                                                        },
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999
                                                                    })
                                                                }}
                                                                menuPortalTarget={document.body}
                                                                menuShouldScrollIntoView={false}
                                                            />
                                                        </div>
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={() => setShowAddBookModal(true)}
                                                            title="Add New Book"
                                                            className="p-0 text-success"
                                                        >
                                                            <i className="fs-4 fa-solid fa-plus-square"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '8%' }}>
                                                    <Form.Control
                                                        type="number"
                                                        value={row.quantity}
                                                        onChange={(e) => handleMultiRowChange(index, "quantity", e.target.value)}
                                                        min="1"
                                                        className="border-0 p-2"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '10%' }}>
                                                    <Form.Control
                                                        type="number"
                                                        value={row.unit_price}
                                                        onChange={(e) => handleMultiRowChange(index, "unit_price", e.target.value)}
                                                        min="0"
                                                        step="0.01"
                                                        className="border-0 p-2"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <div className="bg-light p-2 rounded text-center">
                                                        <span className="fw-semibold text-primary">
                                                            {company?.currency} {((parseFloat(row.quantity) || 0) * (parseFloat(row.unit_price) || 0)).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <Form.Control
                                                        type="date"
                                                        value={row.purchase_date}
                                                        onChange={(e) => handleMultiRowChange(index, "purchase_date", e.target.value)}
                                                        className="border-0 p-2"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '15%' }}>
                                                    <Form.Control
                                                        type="text"
                                                        value={row.notes}
                                                        onChange={(e) => handleMultiRowChange(index, "notes", e.target.value)}
                                                        placeholder="Add notes..."
                                                        className="border-0 p-2"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="text-center p-1" style={{ width: '3%', minWidth: '50px' }}>
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        onClick={() => handleRemoveRow(index)}
                                                        disabled={multiInsertRows.length === 1}
                                                        title="Remove Row"
                                                        className="p-1 text-danger"
                                                        style={{ minWidth: '30px' }}
                                                    >
                                                        <i className="fa-solid fa-trash fa-sm"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    {/* <tbody>
                                        {multiInsertRows.map((row, index) => (
                                            <tr key={index} className={index % 2 === 0 ? 'table-row-light' : ''}>
                                                <td className="border-end p-2" style={{ width: '20%' }}>
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <div className="flex-grow-1">
                                                            <Select
                                                                value={getSelectedVendorForRow(index)}
                                                                onChange={(selectedOption) => handleMultiRowChange(index, "vendor_id", selectedOption ? selectedOption.value : "")}
                                                                options={vendorOptions}
                                                                placeholder="Select Vendor"
                                                                isClearable
                                                                isSearchable
                                                                menuPlacement="auto"
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        width: "200px",
                                                                        minHeight: "36px",
                                                                        fontSize: "14px",
                                                                        borderColor: state.isFocused ? "#8b5cf6" : row.vendor_id ? "#28a745" : "#dee2e6",
                                                                        backgroundColor: row.vendor_id ? "#f8fff9" : "white",
                                                                        "&:hover": {
                                                                            borderColor: row.vendor_id ? "#28a745" : "#8b5cf6",
                                                                        },
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999
                                                                    })
                                                                }}
                                                                menuPortalTarget={document.body}
                                                                menuShouldScrollIntoView={false}
                                                            />
                                                        </div>
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={() => setShowAddVendorModal(true)}
                                                            title="Add New Vendor"
                                                            className="p-0 text-primary"
                                                        >
                                                            <i className="fs-4 fa-solid fa-plus-square"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '25%' }}>
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <div className="flex-grow-1">
                                                            <Select
                                                                value={getSelectedBook(index)}
                                                                onChange={(selectedOption) => handleMultiRowChange(index, "book_id", selectedOption ? selectedOption.value : "")}
                                                                options={bookOptions}
                                                                placeholder="Select Book"
                                                                isClearable
                                                                isSearchable
                                                                menuPlacement="auto"
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                           width: "200px",
                                                                        minHeight: "36px",
                                                                        fontSize: "14px",
                                                                        borderColor: state.isFocused ? "#8b5cf6" : row.book_id ? "#28a745" : "#dee2e6",
                                                                        backgroundColor: row.book_id ? "#f8fff9" : "white",
                                                                        "&:hover": {
                                                                            borderColor: row.book_id ? "#28a745" : "#8b5cf6",
                                                                        },
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999
                                                                    })
                                                                }}
                                                                menuPortalTarget={document.body}
                                                                menuShouldScrollIntoView={false}
                                                            />
                                                        </div>
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={() => setShowAddBookModal(true)}
                                                            title="Add New Book"
                                                            className="p-0 text-success"
                                                        >
                                                            <i className="fs-4 fa-solid fa-plus-square"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '8%' }}>
                                                    <Form.Control
                                                        type="number"
                                                        value={row.quantity}
                                                        onChange={(e) => handleMultiRowChange(index, "quantity", e.target.value)}
                                                        min="1"
                                                        className="border-0 p-2"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '10%' }}>
                                                    <Form.Control
                                                        type="number"
                                                        value={row.unit_price}
                                                        onChange={(e) => handleMultiRowChange(index, "unit_price", e.target.value)}
                                                        min="0"
                                                        step="0.01"
                                                        className="border-0 p-2"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <div className="bg-light p-2 rounded text-center">
                                                        <span className="fw-semibold text-primary">
                                                            {company?.currency} {((parseFloat(row.quantity) || 0) * (parseFloat(row.unit_price) || 0)).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <Form.Control
                                                        type="date"
                                                        value={row.purchase_date}
                                                        onChange={(e) => handleMultiRowChange(index, "purchase_date", e.target.value)}
                                                        className="border-0 p-2"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '15%' }}>
                                                    <Form.Control
                                                        type="text"
                                                        value={row.notes}
                                                        onChange={(e) => handleMultiRowChange(index, "notes", e.target.value)}
                                                        placeholder="Add notes..."
                                                        className="border-0 p-2"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="text-center p-2" style={{ width: '5%' }}>
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        onClick={() => handleRemoveRow(index)}
                                                        disabled={multiInsertRows.length === 1}
                                                        title="Remove Row"
                                                        className="p-0 text-danger"
                                                    >
                                                        <i className="fa-solid fa-trash"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody> */}
                                {/* </Table> */}
                            </div>
                        </div >

                        {/* Purchase Summary */}
                        < Row className="mt-4" >
                            <Col lg={8}></Col>
                            <Col lg={4}>
                                <Card className="shadow-sm border-0" style={{
                                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                    borderRadius: '12px'
                                }}>
                                    <Card.Body className="p-4">
                                        <h6 className="fw-bold mb-3 d-flex align-items-center">
                                            <i className="fa-solid fa-clipboard-check me-2 text-primary"></i>
                                            Purchase Summary
                                        </h6>

                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2 p-2 bg-white rounded">
                                                <span className="text-muted">Total Entries</span>
                                                <Badge bg="primary" pill>{multiInsertRows.length}</Badge>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mb-2 p-2 bg-white rounded">
                                                <span className="text-muted">Vendors</span>
                                                <div className="d-flex align-items-center">
                                                    <Badge bg={uniqueVendors.length > 1 ? "warning" : "success"} pill>
                                                        {uniqueVendors.length}
                                                    </Badge>
                                                    {uniqueVendors.length > 1 && (
                                                        <i className="fa-solid fa-exclamation-triangle ms-2 text-warning small"
                                                            title="Multiple vendors selected"></i>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center p-2 bg-white rounded">
                                                <span className="text-muted">Total Books</span>
                                                <Badge bg="info" pill>{totalBooks}</Badge>
                                            </div>
                                        </div>

                                        <div className="p-3 rounded mb-3 text-center" style={{
                                            background: 'linear-gradient(135deg, var(--primary-color) 0%, #8b5cf6 100%)',
                                            color: 'white'
                                        }}>
                                            <small className="text-white-50 text-uppercase">Total Value</small>
                                            <div className="h4 mb-0 fw-bold">{company?.currency} {totalAmount.toFixed(2)}</div>
                                        </div>

                                        <div className="mt-3">
                                            <Button
                                                variant="primary"
                                                className="w-100 mb-2 py-2 fw-bold"
                                                onClick={handleSavePurchases}
                                                disabled={saving || multiInsertRows.length === 0}
                                                style={{
                                                    background: 'linear-gradient(135deg, var(--primary-color) 0%, #8b5cf6 100%)',
                                                    border: 'none'
                                                }}
                                            >
                                                {saving ? (
                                                    <>
                                                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                                                        Saving...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fa-solid fa-save me-2"></i>
                                                        Save Purchases
                                                    </>
                                                )}
                                            </Button>
                                            <Button
                                                variant="outline-secondary"
                                                className="w-100 py-2"
                                                onClick={() => navigate('/purchase')}
                                            >
                                                <i className="fa-solid fa-arrow-left me-2"></i>
                                                Back to List
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row >
                    </>
                );

            case "import":
                return (
                    <PurchaseDataImport
                        selectedFile={selectedFile}
                        onFileChange={handleFileChange}
                        loading={loading}
                        vendors={vendors}
                        books={books}
                    />
                );

            default:
                return null;
        }
    };

    return (
        <>
            <ToastContainer position="top-right" autoClose={2000} />
            <Row className="align-items-center">
                <Col lg={6}></Col>
                <Col lg={6}>
                    <div className="d-flex gap-3 mb-3 justify-content-end">
                        <Card className="shadow-sm border-0" style={{
                            background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                            borderRadius: "10px",
                            border: 'none',
                            width: '220px'
                        }}>
                            <Card.Body className="p-3">
                                <div className="d-flex align-items-center">
                                    <div className="p-2 rounded-circle me-2" style={{
                                        background: 'rgba(13, 110, 253, 0.15)'
                                    }}>
                                        <i className="fa-solid fa-book-open text-primary fa-sm"></i>
                                    </div>
                                    <div>
                                        <p className="mb-0 small text-muted">Issued</p>
                                        <h5 className="mb-0 fw-bold text-primary">{stats.issued}</h5>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>

                        <Card className="shadow-sm border-0" style={{
                            background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                            borderRadius: "10px",
                            border: 'none',
                            width: '220px'
                        }}>
                            <Card.Body className="p-3">
                                <div className="d-flex align-items-center">
                                    <div className="p-2 rounded-circle me-2" style={{
                                        background: 'rgba(40, 167, 69, 0.15)'
                                    }}>
                                        <i className="fa-solid fa-cart-shopping text-success fa-sm"></i>
                                    </div>
                                    <div>
                                        <p className="mb-0 small text-muted">Purchased</p>
                                        <h5 className="mb-0 fw-bold text-success">{stats.purchased}</h5>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>

                        <Card className="shadow-sm border-0" style={{
                            background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
                            borderRadius: "10px",
                            border: 'none',
                            width: '220px'
                        }}>
                            <Card.Body className="p-3">
                                <div className="d-flex align-items-center">
                                    <div className="p-2 rounded-circle me-2" style={{
                                        background: 'rgba(255, 193, 7, 0.15)'
                                    }}>
                                        <i className="fa-solid fa-layer-group text-warning fa-sm"></i>
                                    </div>
                                    <div>
                                        <p className="mb-0 small text-muted">Available</p>
                                        <h5 className="mb-0 fw-bold text-warning">{stats.available}</h5>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </Col>
            </Row>
            <Container fluid className="py-3" style={{
                minHeight: '100vh',
                backgroundColor: '#f5f7fb'
            }}>
                <div className="mb-1">
                    <h4 className="fw-bold text-dark mb-1">
                        <i className="fa-solid fa-cart-plus" style={{ color: 'var(--primary-color)' }}></i>
                        Bulk Purchase Entry
                    </h4>
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        className="custom-tabs"
                        id="purchase-tabs"
                    >
                        <Tab
                            eventKey="single"
                            title={
                                <div className="d-flex align-items-center px-3 py-2">
                                    Single Vendor
                                </div>
                            }
                            className="pt-3"
                        />
                    </Tabs>
                </div>

                <Row>
                    <Col lg={12}>
                        <Card className="shadow-sm border-0" style={{
                            background: 'white',
                            borderRadius: '12px'
                        }}>
                            <Card.Body className="p-4">
                                {renderTabContent()}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Add Vendor Modal */}
                <Modal backdrop="static" show={showAddVendorModal} onHide={() => setShowAddVendorModal(false)} size="lg" centered>
                    <Modal.Header closeButton className="border-bottom-0 pb-2"
                        style={{ backgroundColor: "var(--secondary-color)", color: "var(--primary-color)" }}>
                        <Modal.Title className="fw-bold">
                            Add New Vendor
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-0">
                        <Form>
                            {/* ---------------- Contact Information ---------------- */}
                            <div className="mt-2 mb-4">
                                <div
                                    className="d-flex align-items-center mt-2 p-2"
                                    style={{ backgroundColor: "var(--secondary-color)", color: "var(--primary-color)", borderRadius: "8px" }}>

                                    <h6 className="mb-0 fw-bold" style={{ color: "var(--primary-color)" }}>
                                        Contact Person Information
                                    </h6>
                                </div>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Contact Person Name<span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={vendorFormData.name}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        name: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter contact person name"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Company Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={vendorFormData.company_name}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        company_name: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter company name"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Country Code</Form.Label>
                                            <Form.Select
                                                value={vendorFormData.country_code}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        country_code: e.target.value,
                                                    })
                                                }
                                            >
                                                {COUNTRY_CODES.map((country, index) => (
                                                    <option key={index} value={country.country_code}>
                                                        {country.country_code} - {country.country}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone</Form.Label>
                                            <Form.Control
                                                type="tel"
                                                value={vendorFormData.phone}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        phone: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter phone number"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                value={vendorFormData.email}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        email: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter email address"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>

                            {/* ---------------- Company Information ---------------- */}
                            <div className="mb-3">
                                <div
                                    className="d-flex align-items-center mb-3 p-2"
                                    style={{ backgroundColor: "var(--secondary-color)", color: "var(--primary-color)", borderRadius: "8px" }}>


                                    <h6 className="mb-0 fw-bold" style={{ color: "var(--primary-color)" }}>
                                        Company Information
                                    </h6>
                                </div>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>GST Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={vendorFormData.gst_number}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        gst_number: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter GST number"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>PAN Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={vendorFormData.pan_number}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        pan_number: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter PAN number"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Country</Form.Label>
                                            <Form.Select
                                                value={vendorFormData.country}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        country: e.target.value,
                                                        state: "",
                                                        city: "",
                                                    })
                                                }
                                            >
                                                {Country.getAllCountries().map((country) => (
                                                    <option key={country.isoCode} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>State</Form.Label>
                                            <Form.Select
                                                value={vendorFormData.state}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        state: e.target.value,
                                                        city: "",
                                                    })
                                                }
                                            >
                                                {State.getStatesOfCountry(
                                                    Country.getAllCountries().find(
                                                        (c) => c.name === vendorFormData.country
                                                    )?.isoCode
                                                ).map((state) => (
                                                    <option key={state.isoCode} value={state.name}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>City</Form.Label>
                                            <Form.Select
                                                value={vendorFormData.city}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        city: e.target.value,
                                                    })
                                                }
                                            >
                                                {City.getCitiesOfState(
                                                    Country.getAllCountries().find(
                                                        (c) => c.name === vendorFormData.country
                                                    )?.isoCode,
                                                    State.getStatesOfCountry(
                                                        Country.getAllCountries().find(
                                                            (c) => c.name === vendorFormData.country
                                                        )?.isoCode
                                                    ).find((s) => s.name === vendorFormData.state)?.isoCode
                                                ).map((city) => (
                                                    <option key={city.name} value={city.name}>
                                                        {city.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Pincode</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={vendorFormData.pincode}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        pincode: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter pincode"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Address</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                value={vendorFormData.address}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        address: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter full address"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className='mb-3'>
                                            <Form.Label>Status</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                checked={vendorFormData.status}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        status: e.target.checked,
                                                    })
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="border-top-0">
                        <Button variant="outline-secondary" onClick={() => setShowAddVendorModal(false)} style={{ borderColor: "var(--primary-color)", color: "var(--primary-color)" }}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleAddVendor} disabled={loading} style={{ borderColor: "var(--primary-color)", color: "var(--primary-color)" }}>
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    Adding...
                                </>
                            ) : (
                                <>
                                    Save
                                </>
                            )}
                        </Button>
                    </Modal.Footer>


                </Modal>



                {/* Add Book Modal */}
                <Modal show={showAddBookModal} onHide={() => {
                    setShowAddBookModal(false);
                    setBarcodeInput("");
                }} size="lg" centered>
                    <Modal.Header closeButton className=" p-2" style={{ backgroundColor: "var(--secondary-color)", color: "var(--primary-color)" }}>
                        <Modal.Title className="fw-bold">
                            <i className="fa-solid fa-book me-2" style={{ color: "var(--primary-color)" }}> </i>
                            Add New Book
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-0">
                        <Card className="mb-4 border-0">
                            <Card.Body className="p-3">
                                <UniversalBarcodeScanner onBarcodeScanned={handleBarcodeScanned} />

                                <Form.Group>
                                    <Form.Label className="small fw-semibold">Enter ISBN/Barcode</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            value={barcodeInput}
                                            placeholder="Enter ISBN or barcode number"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setBarcodeInput(value);

                                                if (autoLookupTimeout) clearTimeout(autoLookupTimeout);

                                                if (value.length >= 10) {
                                                    const timeout = setTimeout(() => handleBarcodeLookup(value), 1500);
                                                    setAutoLookupTimeout(timeout);
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") handleBarcodeLookup(barcodeInput);
                                            }}
                                        />
                                        <Button
                                            variant="primary"
                                            onClick={() => handleBarcodeLookup(barcodeInput)}
                                            disabled={!barcodeInput.trim() || loading || barcodeProcessing}
                                        >
                                            {loading || barcodeProcessing ? (
                                                <i className="fa-solid fa-spinner fa-spin"></i>
                                            ) : (
                                                <i className="fa-solid fa-search"></i>
                                            )}
                                        </Button>
                                    </InputGroup>
                                </Form.Group>

                            </Card.Body>
                        </Card>

                        <Form>
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Title<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={bookFormData.title}
                                            onChange={(e) => setBookFormData({ ...bookFormData, title: e.target.value })}
                                            placeholder="Enter book title"
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Author<span className="text-danger">*</span></Form.Label>
                                        <Select
                                            value={getSelectedAuthor()}
                                            onChange={(selectedOption) => setBookFormData({
                                                ...bookFormData,
                                                author_id: selectedOption ? selectedOption.value : ""
                                            })}
                                            options={authorOptions}
                                            placeholder="Select Author"
                                            isClearable
                                            isSearchable
                                            styles={{
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999
                                                })
                                            }}
                                            menuPortalTarget={document.body}
                                            menuShouldScrollIntoView={false}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Category<span className="text-danger">*</span></Form.Label>
                                        <Select
                                            value={getSelectedCategory()}
                                            onChange={(selectedOption) => setBookFormData({
                                                ...bookFormData,
                                                category_id: selectedOption ? selectedOption.value : ""
                                            })}
                                            options={categoryOptions}
                                            placeholder="Select Category"
                                            isClearable
                                            isSearchable
                                            styles={{
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999
                                                })
                                            }}
                                            menuPortalTarget={document.body}
                                            menuShouldScrollIntoView={false}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>ISBN/Barcode</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={bookFormData.isbn}
                                            onChange={(e) => setBookFormData({ ...bookFormData, isbn: e.target.value })}
                                            placeholder="Enter ISBN or barcode number"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Language</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={bookFormData.language}
                                            onChange={(e) => setBookFormData({ ...bookFormData, language: e.target.value })}
                                            placeholder="Enter language"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="border-top-0">
                        <Button variant="outline-secondary" onClick={() => {
                            setShowAddBookModal(false);
                            setBarcodeInput("");
                        }}>
                            Cancel
                        </Button>
                        <Button variant="success" onClick={handleAddBook} disabled={loading}>
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" style={{ borderColor: "var(--primary-color)", color: "var(--primary-color)" }}></span>
                                    Adding...
                                </>
                            ) : (
                                <>
                                    <i className="fa-solid fa-plus me-2"></i>
                                    Save
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <style>{`
                .custom-tabs .nav-link {
                    border: none;
                    color: #6c757d;
                    font-weight: 500;
                    margin-right: 0.5rem;
                    border-radius: 8px 8px 0 0;
                    transition: all 0.3s ease;
                }
                .custom-tabs .nav-link:hover {
                    color: var(--primary-color);
                    background-color: rgba(111, 66, 193, 0.1);
                }
                .custom-tabs .nav-link.active {
                    color: var(--primary-color);
                    background-color: white;
                    border-bottom: 3px solid var(--primary-color);
                    font-weight: 600;
                }
                .custom-tabs .nav-tabs {
                    border-bottom: 1px solid #dee2e6;
                }
                .table-row-light {
                    background-color: #fafafa;
                }
                .table-row-light:hover {
                    background-color: #f0f0f0;
                }
                .react-select__menu {
                    z-index: 9999 !important;
                }
                .react-select__menu-portal {
                    z-index: 9999 !important;
                }
            `}</style>
            </Container>
        </>
    );
};

export default BulkPurchasePage;